import React from 'react';
import './styles/Global.css';
import ReactDOM from 'react-dom';
import Dictionary from './Dictionary';
import reportWebVitals from './reportWebVitals';
import { QueryClient, QueryClientProvider } from 'react-query';

const queryClient = new QueryClient();
ReactDOM.render(
  <QueryClientProvider client={queryClient}>
    <React.StrictMode>
      <Dictionary />
    </React.StrictMode>
  </QueryClientProvider>,
  document.getElementById('root')
);
reportWebVitals();
